module.exports = __webpack_public_path__ + "static/media/img-02.0c351094.jpg";